import React, { Component, PropTypes } from 'react';
import ConnectionsFilterItem from './connections-filter-item';

class ConnectionsToolbar extends Component {

  render() {
    const { filterOptions } = this.props;
    return (
        <div>
          {filterOptions.map((filterOption, key) => <ConnectionsFilterItem key={key} {...filterOption} />)}
        </div>
    );
  }
}

ConnectionsToolbar.propTypes = {
  filterOptions: PropTypes.array,
};

export default ConnectionsToolbar;



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-toolbar/connections-toolbar.jsx